import Vue from 'vue'
import VueRouter from 'vue-router'
import { constantRoutes } from './routes'

Vue.use(VueRouter)

/**
 * 全局处理 Vue Router 3.x 导航重定向/重复跳转导致的 Promise 异常
 * （如路由守卫中 next({ ...to, replace: true }) 会 reject 原始 push 调用）
 * 注意：vue-router 3.x 的导航错误并未设置 error.name（默认仍为 'Error'），
 * 只能通过官方静态方法 VueRouter.isNavigationFailure(err)（内部判断 err._isRouter）识别
 * 仅吞掉导航类错误，其他真实错误继续抛出
 */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) {
      return err
    }
    throw err
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) {
      return err
    }
    throw err
  })
}

const router = new VueRouter({
  mode: 'history',
  routes: constantRoutes
})

export default router
